import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrPuppetPinIcon = React.memo<IconProps>(({
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    {/* 푸시핀: 머리 + 목 + 바늘 */}
    <path
      d="M14.5 2c.28 0 .53.11.71.29l6.5 6.5a1 1 0 0 1 0 1.42c-.9.9-2.2 1.1-3.33.72l-3.4 3.4c.5 1.63.12 3.47-1.17 4.76a1 1 0 0 1-1.42 0L9 15.7l-5.79 5.8a1 1 0 0 1-1.42-1.42L7.6 14.3l-3.4-3.39a1 1 0 0 1 0-1.42c1.29-1.29 3.13-1.67 4.76-1.17l3.4-3.4c-.38-1.13-.18-2.43.72-3.33.18-.18.43-.29.71-.29h.71ZM14.9 4.5c-.1.42 0 .89.34 1.23l.3.3a1 1 0 0 1 0 1.41l-4.5 4.5a1 1 0 0 1-1.13.2c-.83-.4-1.79-.4-2.6-.02l7.36 7.36c.38-.81.38-1.77-.02-2.6a1 1 0 0 1 .2-1.13l4.5-4.5a1 1 0 0 1 1.41 0l.3.3c.34.34.81.44 1.23.34L14.9 4.5Z"
      fill={color}
    />
  </BaseIcon>
));

AttrPuppetPinIcon.displayName = 'AttrPuppetPinIcon';
